import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

class Addresses extends React.Component {
  render() {
    let { classNamePrefix } = this.props;
    return (
      <div className="addresses">
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>City</TableCell>
                <TableCell>State</TableCell>
                <TableCell>ZIP</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props?.addresses
                ?.sort((a, b) => a?.order - b?.order)
                ?.map(({ type = '', address = '', address1 = '', city = '', stateAbbr = '', zip = '' }) => {
                  return (
                    <TableRow key={type + address1 + city + stateAbbr + zip}>
                      <TableCell className={classNamePrefix + 'type'}>{type}</TableCell>
                      <TableCell className={classNamePrefix + 'address'}>{address1}</TableCell>
                      <TableCell className={classNamePrefix + 'city'}>{city}</TableCell>
                      <TableCell className={classNamePrefix + 'state'}>{stateAbbr}</TableCell>
                      <TableCell className={classNamePrefix + 'zip'}>{zip}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

export default Addresses;
